export default function LogoWhite() {
  return (
    <svg
      width="106"
      height="23"
      viewBox="0 0 106 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_849)">
        <path
          d="M102.55 0V8.6319C101.454 7.51755 99.822 6.9 97.9728 6.9C93.3318 6.9 90.1645 10.5858 90.1645 14.95C90.1645 19.3143 93.3318 23 97.9728 23C99.8163 23 101.454 22.3801 102.55 21.2347V22.6907H106V0H102.55ZM102.55 17.7365C101.736 18.975 100.387 19.9031 98.3795 19.9031C95.6143 19.9031 93.7075 17.6744 93.7075 14.9489C93.7075 12.2234 95.6201 9.99465 98.3795 9.99465C100.387 9.99465 101.736 10.9239 102.55 12.1313V17.7365Z"
          fill="white"
        />
        <path
          d="M12.3859 8.54677C11.2913 7.43242 9.65867 6.81372 7.80828 6.81372C3.16733 6.81372 0 10.4937 0 14.8637C0 19.2337 3.16733 22.9137 7.80828 22.9137C9.65867 22.9137 11.289 22.295 12.3859 21.1485V22.6044H15.8355V7.12307H12.3859V8.54677ZM12.3859 17.6513C11.5713 18.8899 10.2221 19.8191 8.21615 19.8191C5.45093 19.8191 3.54293 17.5892 3.54293 14.8637C3.54293 12.1382 5.4567 9.90952 8.21615 9.90952C10.2221 9.90952 11.5713 10.8387 12.3859 12.0462V17.6513Z"
          fill="white"
        />
        <path
          d="M48.1079 6.79883C43.4669 6.79883 39.8917 10.3638 39.8917 14.8488C39.8917 19.3338 43.4635 22.8988 48.1079 22.8988C52.7523 22.8988 56.324 19.3338 56.324 14.8488C56.324 10.3638 52.7488 6.79883 48.1079 6.79883ZM48.1079 19.7421C45.3173 19.7421 43.3736 17.6054 43.3736 14.85C43.3736 12.0946 45.3173 9.95673 48.1079 9.95673C50.8673 9.95673 52.8122 12.0934 52.8122 14.85C52.8122 17.6065 50.8673 19.7421 48.1079 19.7421Z"
          fill="white"
        />
        <path
          d="M68.6696 16.0677C68.6696 17.1153 68.3377 18.0146 67.7098 18.669C67.0819 19.3233 66.212 19.6706 65.2038 19.6706C64.1957 19.6706 63.3373 19.3256 62.7117 18.6701C62.086 18.0146 61.7565 17.1153 61.7565 16.0677V7.12988H58.2862V16.5852C58.2862 18.4252 58.9533 20.0041 60.2149 21.153C61.4765 22.3018 63.1956 22.901 65.2027 22.901C67.2097 22.901 68.9127 22.2857 70.1685 21.1231C71.4244 19.9604 72.0961 18.3562 72.1042 16.4943V7.12988H68.6696V16.0677Z"
          fill="white"
        />
        <path
          d="M86.2437 8.54805C84.9878 7.40495 83.263 6.80005 81.2559 6.80005C79.2488 6.80005 77.5413 7.41415 76.2912 8.57795C75.0411 9.74175 74.3625 11.3448 74.3544 13.2067V22.5033H77.7913V13.6299C77.7913 12.5823 78.122 11.6818 78.7499 11.0274C79.3779 10.3731 80.2478 10.0269 81.2559 10.0269C82.2641 10.0269 83.1224 10.3719 83.7481 11.0274C84.3737 11.683 84.7055 12.5823 84.7055 13.6299V22.5999H88.1724V13.1124C88.1724 11.2758 87.5053 9.6969 86.2437 8.54805Z"
          fill="white"
        />
        <path
          d="M29.748 6.7988C28.4681 6.79286 27.2036 7.07675 26.0495 7.6291L26.0437 7.6199L25.902 7.70155C25.5831 7.86241 25.2752 8.04412 24.9803 8.2455V0H21.5238V11.4908C19.142 14.4755 17.8403 18.1757 17.8299 21.9915V22.6067H21.0226V21.888C21.0394 20.2999 21.3333 18.7269 21.8913 17.2397C22.9018 20.5402 25.9735 22.9 29.7526 22.9C34.3935 22.9 37.9676 19.335 37.9676 14.85C37.9676 10.365 34.3889 6.7988 29.748 6.7988ZM29.763 19.7421C26.9724 19.7421 25.0287 17.6054 25.0287 14.85C25.0287 12.0946 26.9724 9.9567 29.763 9.9567C32.5224 9.9567 34.4673 12.0934 34.4673 14.85C34.4673 17.6065 32.5224 19.7421 29.763 19.7421Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_849">
          <rect width="106" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
